import { animated } from "@react-spring/web";
import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL_IMG } from "../../constants";
import LazyLoad from "react-lazy-load";
import defaultImage from "../../../assets/players_shadow/player.png";

function PlayerCard({ data, style, hoverIn, hoverOut, transformed, mobile }) {
  const [baseUrl, setBaseUrl] = useState();
  let name = data.name.trim().replace(/\s/g, "");
  let surname = data.surname.trim().replace(/\s/g, "");
  useEffect(() => {
    if (data) {
      setBaseUrl(BASE_URL_IMG + data.img_profile_url);
    }
  }, [data]);
  const navigate = useNavigate();

  return (
    <animated.div
      onClick={() => navigate(`/players/${data.id}-${name}-${surname}#playerProfile`)}
      onMouseEnter={hoverIn}
      onMouseLeave={hoverOut}
      style={style}
      className={`player-card ${
        transformed === true ? "player-card--home" : "player-card--page"
      } ${mobile ? "player-card--mobile" : ""}`}
    >
      <div className="image-players">
        <div className="img-container">
          <LazyLoad height={"100%"} offset={300}>
            <img
              src={baseUrl}
              alt={`player-${data.name}`}
              onError={(e) => {
                e.target.src = defaultImage;
                e.target.style.height = "95%";
              }}
            />
          </LazyLoad>
        </div>
      </div>

      <div className="text-container">
        <span className="player-name">{data.name}</span>
        <span className="player-surname">{data.surname}</span>
      </div>
    </animated.div>
  );
}

export default PlayerCard;
